module.exports = __webpack_public_path__ + "static/media/mallorca.32fb99ef.jpg";